import SavedPaymentMethod from './SavedPaymentMethod'

export default SavedPaymentMethod
